import { useEffect } from 'react';
import type { RegisterOptions } from 'react-hook-form';
import useCallingCodes from './useCallingCodes';
import usePhoneDetails from './usePhoneDetails';

type Props = {
  value: string;
  onChange: (phoneString: string) => void;
  error?: string;
  rules?: RegisterOptions;
};

const usePhoneFields = ({ onChange, value }: Props) => {
  const {
    countryCode,
    countryNumber,
    phoneNumber,
    handleCodeChange,
    handleNumberChange,
  } = usePhoneDetails({ value });
  const { primaryOptions, secondaryOptions } = useCallingCodes();

  useEffect(() => {
    if (phoneNumber === '') {
      onChange('');
    }
    if (phoneNumber) {
      const phoneString =
        countryCode && phoneNumber
          ? `+${countryNumber}${phoneNumber}`
          : phoneNumber?.toString();
      onChange(phoneString);
    }
  }, [countryCode, countryNumber, onChange, phoneNumber]);

  return {
    countryCode,
    phoneNumber: phoneNumber?.toString(),
    primaryOptions,
    secondaryOptions,
    handleCodeChange,
    handleNumberChange,
  };
};

export default usePhoneFields;
